module.exports = "/virtual-football/img/video/clubs/france/psg.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/france/psg.png
// module id = 293
// module chunks = 6